import { Link } from 'react-router-dom';

export default function ArticleCTA() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20workspace%20with%20open%20notebook%20and%20laptop%20on%20rich%20wooden%20desk%2C%20soft%20natural%20daylight%20from%20side%20window%2C%20ceramic%20mug%20and%20small%20plant%2C%20warm%20cream%20and%20terracotta%20accents%2C%20editorial%20lifestyle%20photography%2C%20calm%20inspiring%20atmosphere&width=1200&height=500&seq=sugargoo-article-cta-bg-v2&orientation=landscape"
              alt="Read Sugargoo Spreadsheet guide and articles"
              className="w-full h-full object-cover"
              title="Sugargoo Spreadsheet Complete Guide"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/20"></div>

          <div className="relative z-10 p-8 md:p-12 lg:p-14 flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-10">
            <div className="flex-1">
              <p className="text-white/70 text-xs md:text-sm uppercase tracking-widest font-semibold mb-3">In-Depth Guide</p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3 leading-tight">
                Sugargoo Spreadsheet: The Complete 2026 Guide
              </h2>
              <p className="text-white/75 text-sm md:text-base leading-relaxed max-w-lg">
                Learn everything about the Sugargoo Spreadsheet — how it works, why it saves you time, and how to use it for smarter shopping decisions. Our comprehensive guide covers product discovery, category navigation, and expert tips.
              </p>
            </div>
            <Link
              to="/article/sugargoo-spreadsheet-complete-guide"
              className="shrink-0 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all whitespace-nowrap"
            >
              Read the Full Guide <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}